export var key = 'trimmingsToggle';
export var eventNames = ['click', 'input', 'change'];
export var render = function render() {
  if (document.body && !document.body.classList.contains('trimmings')) {
    document.body.classList.add('trimmings');
  }
};